import React from "react";
import { LoadingIndicator } from "@jsq/ds/core";
import { MISSING_VALUE_PLACEHOLDER } from "../../common/constants";
import { BaseCompletionCard } from "../BaseCompletionCard";
import { ProfileRefreshCompletionCardProps } from "./types";

export const ProfileRefreshCompletionCard = ({
  accountName,
  onClose,
}: ProfileRefreshCompletionCardProps) => {
  if (!accountName || accountName === MISSING_VALUE_PLACEHOLDER) {
    return <LoadingIndicator />;
  }

  return (
    <BaseCompletionCard
      title={`${accountName}'s information refresh is complete`}
      onClose={onClose}
    />
  );
};
